export const EXPIRES_COOKIES = 365;

export default EXPIRES_COOKIES;
